import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export interface MapHotspot {
	x: number;
	y: number;
	image?: string;
	name?: string;
	description?: string;
	link?: string | null;
	[key: string]: unknown;
}

export interface MapMarkerData {
	image?: string;
	title?: string;
	description?: string;
	pageID?: string[];
	[key: string]: unknown;
}

interface MapStoreState {
	mapScale: number;
	showMarkerInfoFooter: boolean;
	mapHasInteraction: boolean;
	hideInfoBoxes: boolean;
	markerData: MapMarkerData | null;
	hotspots: MapHotspot[];
}

const initialState: MapStoreState = {
	mapScale: 1,
	showMarkerInfoFooter: false,
	mapHasInteraction: false,
	hideInfoBoxes: false,
	markerData: null,
	hotspots: [],
};

export const useMapStore = create(
	combine(initialState, (set, get) => ({
		updateMapScale: (newScale: number) => set({ mapScale: newScale }),

		setHotspots: (data: MapHotspot[]) => set({ hotspots: data }),

		setShowMarkerInfoFooter: (data: boolean) => set({ showMarkerInfoFooter: data }),

		showMarkerInfo: (data: MapMarkerData) => {
			const { markerData } = get();
			const isSameData = markerData === data;
			set({
				mapHasInteraction: true,
				hideInfoBoxes: false,
				markerData: data,
				showMarkerInfoFooter: !isSameData,
			});
		},

		hideInfoBox: () => {
			set({ mapHasInteraction: false });
		},
	})),
);
